import { createApi } from '@reduxjs/toolkit/query/react'
import { API } from 'aws-amplify'
import { getTagById } from '~map-search/api/getTagById'
import { getTagsByIds } from '~map-search/api/getTagsByIds'
import { searchTags } from '~map-search/api/searchTags'

export const amplifyGraphqlBaseQuery = async ({ query, variables }) => {
  try {
    const result = await API.graphql({
      query,
      variables
    })
    return { data: result.data }
  } catch (error) {
    return { error }
  }
}

const tagApi = createApi({
  reducerPath: 'tagApi',
  baseQuery: amplifyGraphqlBaseQuery,
  endpoints: (builder) => ({
    getTagById: builder.query({
      queryFn: async (id) => {
        try {
          const data = await getTagById(id)
          return { data }
        } catch (error) {
          return { error }
        }
      }
    }),

    getTagsByIds: builder.query({
      queryFn: async (ids) => {
        try {
          const data = await getTagsByIds(ids)
          return { data }
        } catch (error) {
          return { error }
        }
      }
    }),

    searchTags: builder.query({
      queryFn: async ({ from, size, query, types }) => {
        try {
          const data = await searchTags({ from, size, query, types })
          return { data }
        } catch (error) {
          return { error }
        }
      }
    })
  })
})

export const {
  useLazyGetTagByIdQuery,
  useLazyGetTagsByIdsQuery,
  useSearchTagsQuery,
  useLazySearchTagsQuery
} = tagApi
export default tagApi
